// extracted by mini-css-extract-plugin
export var icon = "_sb-0";